<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_payment && localService.languageContent.payment_gateway_cust_config">
        <div *ngIf="isTermsAccepted == false" class="center" style="max-width: 800px;margin-top: 25px;">
            <div class="banner">
                <app-label [Text]="localService.languageContent.payment_gateway_cust_config.disclaimer" />
                <p style="text-align: justify;margin-left: 25px;">
                    {{localService.languageContent.payment_gateway_cust_config.disclaimer_desc}}
                </p>
            </div>
            <div style="text-align: center;">
                <button type="button" class="btn btn-primary" style="margin-top: 25px;"
                    (click)="onAction(1)">{{localService.languageContent.payment_gateway_cust_config.accept_term}}</button>
            </div>
        </div>
        <div *ngIf="isTermsAccepted">
            <div>
                <marquee>
                    <app-label [Text]="localService.languageContent.payment_gateway_cust_config.disclaimer" />
                    <span>{{localService.languageContent.payment_gateway_cust_config.disclaimer_desc}}</span>
                </marquee>
            </div>
            <div class="center" style="max-width:600px;">
                <div class="row">
                    <div class="col-12">
                        <button class="button_icon icon_adjust button_icon_color"
                            (click)="onLoad()">refresh</button>&nbsp;
                        <app-label [Text]="localService.languageContent.qr_payment.configured_gateways" />
                    </div>
                </div>
                <div class="row" *ngIf="itemsConfigured.length == 0">
                    <div class="col-12" style="text-align: justify;">
                        {{localService.languageContent.qr_payment.no_data}}
                    </div>
                </div>
                <div class="banner custom_rows_body" *ngIf="itemsConfigured.length > 0">
                    <div class="row styled_row" *ngFor="let item of itemsConfigured">
                        <div class="col-2">
                            <button class="button_icon icon_adjust button_icon_color"
                                (click)="onAction(2,item.key)">account_tree</button>
                            <button class="button_icon icon_adjust button_icon_color" [disabled]="item.v3 == '1'"
                                title="{{localService.languageContent.qr_payment.is_primary}}"
                                [ngClass]="item.v3 == '1' ? 'material-icons' :'material-icons-outline'"
                                (click)="onAction(3,item.key)">{{item.v3 == '1' ?
                                "check_circle" : "circle"}}</button>
                        </div>
                        <div class="col-10">
                            <span>{{item.v1}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="itemsUnconfigured.length > 0" style="margin-top: 50px;">
                    <div class="row">
                        <div class="col-12">
                            <app-label [Text]="localService.languageContent.qr_payment.unconfigured_gateways" />
                        </div>
                    </div>
                    <div class="banner custom_rows_body" *ngIf="itemsUnconfigured.length > 0">
                        <div class="row styled_row" *ngFor="let item of itemsUnconfigured">
                            <div class="col-2">
                                <button class="button_icon icon_adjust button_icon_color"
                                    (click)="onAction(2,item.key)">account_tree</button>
                            </div>
                            <div class="col-10">
                                <span>{{item.v1}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>